<button
  mat-raised-button
  color="primary"
  class="chat-message-action"
  [attr.aria-label]="title"
  (click)="onActionClick()"
>
  {{ title }}
</button>
